import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {Timeline} from "primereact/timeline";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";


const AuditlogShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "unified-audit-log/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          if (response.data.data.diffs) {
            const diffsArray = Object.entries(response.data.data.diffs).map(([key, value]) => {
              return {
                "entity": key,
                "new": value.new,
                "old": value.old,
              };
            });
            setFormData({...response.data.data, diffs: diffsArray});
          } else {
            setFormData(response.data.data);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderAuditlogList])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {t(formData?.source_table?.replace('_audit', '')) || t('auditlog_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('id')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {/*<i className={"pi pi-window-maximize"}*/}
            {/*   onClick={(e) => {*/}
            {/*     navigate('/' + formData?.source_table?.replace('_audit', '') + '/' + formData.object_id + '/update/')*/}
            {/*   }}*/}
            {/*></i>*/}
            {/*&nbsp;*/}
            {t(formData?.source_table?.replace('_audit', ''))}
            &nbsp;
            {formData.object_id}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('performed_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.perfomed_at).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('user')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData.blame_user}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid audit-log-timeline"}>
          <div className={"p-col-12"}>
            {formData.diffs &&
              <>
                <Timeline align="left"
                          value={formData.diffs}
                          marker={(item, index) => {
                            if (item.old) {
                              return (
                                <i className={"pi pi-refresh"}
                                   style={{
                                     color: "#fff",
                                     fontSize: "1.5rem",
                                     backgroundColor:'#ffc107',
                                     padding:'0.5rem',
                                     borderRadius:'50%',

                                   }}></i>
                              )
                            } else {
                              return (
                                <i className={"pi pi-plus-circle"}
                                   style={{
                                     color: "#fff",
                                     fontSize: "1.5rem",
                                     backgroundColor:'#0abb87',
                                     padding:'0.5rem',
                                     borderRadius:'50%',
                                   }}></i>
                              )
                            }
                          }}
                          content={(item) => {
                            return (
                              <>
                                <div className={"p-text-bold p-mb-3 p-mt-1"} style={{fontSize: '1.2rem'}}>
                                  {item.entity}
                                </div>
                                {item?.new?.toString() &&
                                  <>
                                    <i className={"pi pi-plus"}
                                       style={{
                                         color: "#0abb87",
                                       }}></i>
                                    &nbsp;
                                    {item?.new?.id?.toString() || item?.new?.toString()}
                                  </>
                                }
                                {item?.old?.toString() &&
                                <>
                                  <hr />
                                  <i className={"pi pi-minus"}
                                     style={{
                                       color: "#ff7f7f",
                                     }}></i>
                                  &nbsp;
                                  {item?.old?.toString()}
                                </>
                                }
                              </>
                            )
                          }}
                />
              </>
            }
          </div>
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(AuditlogShowComponent);
